// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 款式列表 POST /printSystem/goods/getList */
export async function postPrintSystemGoodsGetList(body: any, options?: { [key: string]: any }) {
  return request('/printSystem/goods/getList', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    isMhm: true,
    ...(options || {}),
  });
}

/** 款式详情 GET /printSystem/goods/detail */
export async function getPrintSystemGoodsDetail(body: any, options?: { [key: string]: any }) {
  return request('/printSystem/goods/detail', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params: body,
    data: body,
    isMhm: true,
    ...(options || {}),
  });
}

/** 款式详情 GET /printSystem/goods/shareDetail */
export async function getPrintSystemGoodsShareDetail(body: any, options?: { [key: string]: any }) {
  return request('/printSystem/goods/shareDetail', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params: body,
    data: body,
    isMhm: true,
    checkBaoban: true,
    ...(options || {}),
  });
}

/** 款式新增 POST /printSystem/goods/add */
export async function postPrintSystemGoodsAdd(body: any, options?: { [key: string]: any }) {
  return request('/printSystem/goods/add', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    isMhm: true,
    ...(options || {}),
  });
}

/** 款式编辑 POST /printSystem/goods/edit */
export async function postPrintSystemGoodsEdit(body: any, options?: { [key: string]: any }) {
  return request('/printSystem/goods/edit', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    isMhm: true,
    ...(options || {}),
  });
}

/** 款式删除 POST /printSystem/goods/delete */
export async function postPrintSystemGoodsDelete(body: any, options?: { [key: string]: any }) {
  return request('/printSystem/goods/delete', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    isMhm: true,
    ...(options || {}),
  });
}

/** 款式批量导入 POST /printSystem/goods/batchImport */
export async function postPrintSystemGoodsBatchImport(body: any, options?: { [key: string]: any }) {
  return request('/printSystem/goods/batchImport', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    isMhm: true,
    ...(options || {}),
  });
}

/** 获取款式基础字段 GET /printSystem/goods/getBaseFiled */
export async function getPrintSystemGoodsGetBaseFiled(
  body?: any,
  options?: { [key: string]: any },
) {
  return request('/printSystem/goods/getBaseFiled', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params: body,
    data: body,
    isMhm: true,
    ...(options || {}),
  });
}

/** 款式上传图片 POST /printSystem/goods/uploadImg */
export async function postPrintSystemGoodsUploadImg(body: any, options?: { [key: string]: any }) {
  return request('/printSystem/goods/uploadImg', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    isMhm: true,
    ...(options || {}),
  });
}

/** 上传临时文件 POST /printSystem/goods/uploadTemporaryFile */
export async function postPrintSystemGoodsUploadTemporaryFile(
  body: any,
  options?: { [key: string]: any },
) {
  return request('/printSystem/goods/uploadTemporaryFile', {
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: body,
    isMhm: true,
    ...(options || {}),
  });
}

/** 获取打印模板列表 GET /printSystem/template/getList */
export async function getPrintSystemTemplateGetList(body: any, options?: { [key: string]: any }) {
  return request('/printSystem/template/getList', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params: body,
    data: body,
    isMhm: true,
    ...(options || {}),
  });
}

/** 获取打印模板详情 GET /printSystem/template/detail */
export async function getPrintSystemTemplateDetail(body: any, options?: { [key: string]: any }) {
  return request('/printSystem/template/detail', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params: body,
    data: body,
    isMhm: true,
    ...(options || {}),
  });
}

/** 新增打印模板 POST /printSystem/template/add */
export async function postPrintSystemTemplateAdd(body: any, options?: { [key: string]: any }) {
  return request('/printSystem/template/add', {
    method: 'Post',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    isMhm: true,
    ...(options || {}),
  });
}

/** 编辑打印模板 POST /printSystem/template/edit */
export async function postPrintSystemTemplateEdit(body: any, options?: { [key: string]: any }) {
  return request('/printSystem/template/edit', {
    method: 'Post',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    isMhm: true,
    ...(options || {}),
  });
}

/** 删除打印模板 POST /printSystem/template/delete */
export async function postPrintSystemTemplateDelete(body: any, options?: { [key: string]: any }) {
  return request('/printSystem/template/delete', {
    method: 'Post',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    isMhm: true,
    ...(options || {}),
  });
}

/** 设置默认打印模板 POST /printSystem/template/switchDefault */
export async function postPrintSystemTemplateSwitchDefault(
  body: any,
  options?: { [key: string]: any },
) {
  return request('/printSystem/template/switchDefault', {
    method: 'Post',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    isMhm: true,
    ...(options || {}),
  });
}

/** 获取打印单详情 GET /printSystem/order/detail */
export async function getPrintSystemOrderDetail(body: any, options?: { [key: string]: any }) {
  return request('/printSystem/order/detail', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params: body,
    data: body,
    isMhm: true,
    ...(options || {}),
  });
}

/** 新增打印单 POST /printSystem/order/add */
export async function postPrintSystemOrderAdd(body: any, options?: { [key: string]: any }) {
  return request('/printSystem/order/add', {
    method: 'Post',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    isMhm: true,
    ...(options || {}),
  });
}

/** 获取打印单sku列表 GET /printSystem/order/getSkuList */
export async function getPrintSystemOrderGetSkuList(body: any, options?: { [key: string]: any }) {
  return request('/printSystem/order/getSkuList', {
    method: 'Get',
    headers: {
      'Content-Type': 'application/json',
    },
    params: body,
    data: body,
    isMhm: true,
    ...(options || {}),
  });
}

/** 获取打印单sku列表 GET /printSystem/order/getSkuList */
export async function getPrintSystemOrderShareGetSkuList(
  body: any,
  options?: { [key: string]: any },
) {
  return request('/printSystem/order/shareGetSkuList', {
    method: 'Get',
    headers: {
      'Content-Type': 'application/json',
    },
    params: body,
    data: body,
    isMhm: true,
    checkBaoban: true,
    ...(options || {}),
  });
}

/** 获取打印单列表 POST /printSystem/order/getList */
export async function postPrintSystemOrderGetList(body: any, options?: { [key: string]: any }) {
  return request('/printSystem/order/getList', {
    method: 'Post',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    isMhm: true,
    ...(options || {}),
  });
}

/** 打印单分享 POST /printSystem/order/share */
export async function postPrintSystemOrderShare(body: any, options?: { [key: string]: any }) {
  return request('/printSystem/order/share', {
    method: 'Post',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    isMhm: true,
    ...(options || {}),
  });
}

/** 打印单删除 POST /printSystem/order/delete */
export async function postPrintSystemOrderDelete(body: any, options?: { [key: string]: any }) {
  return request('/printSystem/order/delete', {
    method: 'Post',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    isMhm: true,
    ...(options || {}),
  });
}

/** 打印单分享详情【分享】 GET /printSystem/order/shareDetail */
export async function getPrintSystemOrderShareDetail(body: any, options?: { [key: string]: any }) {
  return request('/printSystem/order/shareDetail', {
    method: 'Get',
    headers: {
      'Content-Type': 'application/json',
    },
    params: body,
    data: body,
    isMhm: true,
    checkBaoban: true,
    ...(options || {}),
  });
}

/** 打印单开始任务（继续打印） POST /printSystem/order/start */
export async function postPrintSystemOrderStart(body: any, options?: { [key: string]: any }) {
  return request('/printSystem/order/start', {
    method: 'Post',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    isMhm: true,
    ...(options || {}),
  });
}

/** 打印单暂停任务 POST /printSystem/order/pause */
export async function postPrintSystemOrderPause(body: any, options?: { [key: string]: any }) {
  return request('/printSystem/order/pause', {
    method: 'Post',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    isMhm: true,
    ...(options || {}),
  });
}

/** 打印单终止任务 POST /printSystem/order/stop */
export async function postPrintSystemOrderStop(body: any, options?: { [key: string]: any }) {
  return request('/printSystem/order/stop', {
    method: 'Post',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    isMhm: true,
    ...(options || {}),
  });
}

/** 打印单更新打印数量 POST /printSystem/order/updatePrintNum */
export async function postPrintSystemOrderUpdatePrintNum(
  body: any,
  options?: { [key: string]: any },
) {
  return request('/printSystem/order/updatePrintNum', {
    method: 'Post',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    isMhm: true,
    ...(options || {}),
  });
}

/** 打印单开始任务【分享】 POST /printSystem/order/shareStart */
export async function postPrintSystemOrderShareStart(body: any, options?: { [key: string]: any }) {
  return request('/printSystem/order/shareStart', {
    method: 'Post',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    isMhm: true,
    checkBaoban: true,
    ...(options || {}),
  });
}

/** 打印单更新数量【分享】 POST /printSystem/order/shareUpdatePrintNum */
export async function postPrintSystemOrderShareUpdatePrintNum(
  body?: any,
  options?: { [key: string]: any },
) {
  return request('/printSystem/order/shareUpdatePrintNum', {
    method: 'Post',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    isMhm: true,
    checkBaoban: true,
    ...(options || {}),
  });
}

/** 检验爆板登录态 **/
export async function postPostRouterBaobSettingPcSupplyConfig(
  body?: any,
  options?: { [key: string]: any },
) {
  return request('/router/baob/SettingPc/supplyConfig', {
    method: 'Post',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: body,
    isBaoban: true,
    checkBaoban: true,
    ...(options || {}),
  });
}

/** 批量创建草稿 **/
export async function postBaobanGoodsLibPcBatchCreateDraft(
  body?: any,
  options?: { [key: string]: any },
) {
  return request('/router/baoban/GoodsLibPc/batchCreateDraft', {
    method: 'Post',
    headers: {
      // 'Content-Type': 'application/json',
      'Content-Type': 'multipart/form-data',
    },
    data: body,
    isBaoban: true,
    ...(options || {}),
  });
}

/** 创建爆版商品草稿 POST /printSystem/goods/getBatchCreateGoodsDraftList */
export async function postPrintSystemGoodsGetBatchCreateGoodsDraftList(
  body?: any,
  options?: { [key: string]: any },
) {
  return request('/printSystem/goods/getBatchCreateGoodsDraftList', {
    method: 'Post',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    isMhm: true,
    ...(options || {}),
  });
}

/** 获取批量导入结果列表 GET /printSystem/goods/batchImportGetList */
export async function getPrintSystemGoodsBatchImportGetList(
  body?: any,
  options?: { [key: string]: any },
) {
  return request('/printSystem/goods/batchImportGetList', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params: body,
    data: body,
    isMhm: true,
    ...(options || {}),
  });
}
